export default __webpack_public_path__ + "static/media/our_breakfast.72d456eb.png";